import { current } from '@reduxjs/toolkit';
import { addItemToWorkflowTable } from '@/warehouse/helpers';
/** Works for both caches: with *receipted* invoices and with *not receipted* invoices. */
export function updateStockInvoicesByMessage({ draft, isReceipted, message, endpointName, eventName, }) {
    const { stockInvoice } = message;
    // No remove in receipted.
    if (isReceipted && stockInvoice.quantity === stockInvoice.receiptedQuantity) {
        const itemIndex = draft.findIndex((item) => item.stockInvoiceId === stockInvoice.stockInvoiceId);
        if (itemIndex !== -1) {
            // TODO: (later) add error log to backend.
            console.error(`In ${endpointName}() onCacheEntryAdded '${eventName}' event has wrong id: `, stockInvoice.stockInvoiceId);
            console.log(`Invoice that is going to become receipted should not exist in receipted tab list`);
            console.log('Draft:', current(draft));
            console.log('message ', message);
            return;
        }
        addItemToWorkflowTable(draft, stockInvoice, 'stockInvoiceId');
        return;
    }
    // No remove in non receipted.
    if (!isReceipted) {
        const itemIndex = draft.findIndex((item) => item.stockInvoiceId === stockInvoice.stockInvoiceId);
        if (itemIndex === -1) {
            // The following logging should not be sent, because item that is placed may belong to invoice
            // that is not in the list, since the list is filtered by dates period.
            //
            // console.error(`In ${endpointName}() onCacheEntryAdded '${eventName}' event has wrong id: `, stockInvoice.stockInvoiceId);
            // console.log('Invoice with specified ID should exist in the Invoice list.');
            // console.log('Draft:', current(draft));
            // console.log('message ', message);
            return;
        }
        draft[itemIndex].receiptedQuantity = stockInvoice.receiptedQuantity;
    }
}
